import React from 'react';

export { default as routes } from './routes';

export default React.lazy(() => import('./OvvCabinet'));
